<form [formGroup]="form.group" #formDirective="ngForm" [ngClass]="{ 'form-pane': enableHeaderPane || enablePane }" (ngSubmit)="onSave()">
  @if (enableHeaderPane) {
    <div class="form-pane-header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="form-pane-title">@if (headerPaneIcon) {
        <mat-icon>{{ headerPaneIcon }}</mat-icon>
        }<strong>{{ headerPaneTitle }}</strong></span>
        <ng-container *ngTemplateOutlet="messageTempl"></ng-container>
        @if (!busyMessage) {
          <div fxLayoutGap="5px">
            @if (allowCancel) {
              <button [disabled]="!form.group.dirty" class="margin-bottom" mat-raised-button type="button" (click)="onCancel()">Undo</button>
            }
            <ng-content select="button"></ng-content>
            <button type="submit" mat-raised-button color="primary" [disabled]="!form.group.dirty || (enabled$ | async) === false">
              Apply
            </button>
          </div>
        }
      </div>
    }
    <div class="form-fields-container">
      <ng-content select="[beforeFields]"></ng-content>
      @if (showFields) {
        @for (field of form.fieldList; track field) {
          <nuso-form-control
            [field]="field"
            (actionButtonClicked)="actionButtonClicked.emit($event)"
            (fieldClicked)="fieldClicked.emit($event)"
          ></nuso-form-control>
        }
      }
      <ng-content select="[afterFields]"></ng-content>
    </div>
    @if (!hideButtons) {
      <mat-action-row>
        <ng-container *ngTemplateOutlet="messageTempl"></ng-container>
        @if (!busyMessage) {
          <div fxLayoutGap="10px">
            <button class="margin-bottom" type="submit" mat-raised-button color="primary" [disabled]="(enabled$ | async) === false">
              {{saveText}}
            </button>
            <ng-content select="button"></ng-content>
            @if (allowCancel) {
              <button [disabled]="!enableCancel" class="margin-bottom" mat-raised-button type="button" (click)="onCancel()">{{cancelText}}</button>
            }
          </div>
        }
      </mat-action-row>
    }
  </form>

  <ng-template #messageTempl>
    @if (busyMessage) {
      <div>
        <div class="flex-container">
          <nuso-spinner [diameter]="15" [stroke]="2">{{busyMessage}}</nuso-spinner>
        </div>
      </div>
    }
    @if (errorMessage) {
      <strong class="error">{{'common.error' | translate}}: {{errorMessage}}&nbsp;</strong>
      }<br/>
    </ng-template>
